export default {
  // Generic error messages
  networkError: "Network error. Please check your connection and try again.",
  serverError: "Server error. Please contact support if this persists.",
  authError: "Session expired. Please log in again.",
  validationError: "Invalid data. Please check your input.",
  unknownError: "An unexpected error occurred. Please try again.",

  // Operation-specific errors
  fetchFailed: "Failed to load data. Please try again.",
  saveFailed: "Failed to save changes. Please try again.",
  updateFailed: "Failed to update. Please try again.",
  deleteFailed: "Failed to delete. Please try again.",
  createFailed: "Failed to create. Please try again.",
  publishFailed: "Failed to publish. Please try again.",
  refreshFailed: "Failed to refresh. Showing previously loaded data.",

  // Table state messages
  failedToLoad: "Failed to load data",
  failedToLoadHint: "Something went wrong. Please try again.",
  noData: "No data available",
  noMatch: "No matching results",
  noMatchHint: "Try adjusting your filters or search query.",

  // Common actions
  retry: "Retry",
  cancel: "Cancel",
  dismiss: "Dismiss",
};
